import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextField, Stack } from '@mui/material';

function FeedbackDialog({ open, onSubmit, onClose, packFeedback }) {
    const [feedback, setfeedback] = React.useState(packFeedback || '');

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Leave Feedback?</DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Typography>It looks like you’ve left feedback about your usage on very few of these pack items. Please leave any feedback you have about your experience using this tool.</Typography>
                    <TextField
                        multiline
                        minRows={4}
                        value={feedback}
                        onChange={e => setfeedback(e.target.value)}
                        fullWidth
                        label="Feedback"
                        variant="outlined"
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onSubmit(feedback)} color="primary" variant="contained">Submit</Button>
            </DialogActions>
        </Dialog>
    );
}

export default FeedbackDialog;